/**
 * Base 64 to Uint8Array.
 * https://github.com/Minishlink/physbook/blob/02a0d5d7ca0d5d2cc6d308a3a9b81244c63b3f14/app/Resources/public/js/app.js#L177
 * 
 * @param {string} base64String 
 */
const urlBase64ToUint8Array = base64String => {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

    const rawData = window.atob(base64);
    const outputArray = new Uint8Array(rawData.length);

    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }

    return outputArray;
}

/**
 * Convert Vapid public key.
 * 
 * @param {string} vapidPublicKey Vapid public key.
 */
const convertVapidPublicKey = vapidPublicKey => urlBase64ToUint8Array(vapidPublicKey);
exports.convertVapidPublicKey = convertVapidPublicKey;

/**
 * Create base 64 encoded string.
 * 
 * https://developer.mozilla.org/en-US/docs/Web/API/PushSubscription/getKey
 * 
 * @param {} key Key (auth/p256dh).
 */
const convertKeyToBtoa = key => btoa(String.fromCharCode.apply(null, new Uint8Array(key)));
exports.convertKeyToBtoa = convertKeyToBtoa;

/**
 * Convert size in bytes to KB, MB, GB TB, PB, EB, ZB, YB
 *
 * @param {number} bytes
 * @param {number} decimals
 * @return {string}
 */
const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / k ** i).toFixed(dm))} ${sizes[i]}`;
};
exports.formatBytes = formatBytes;
